import { useQuery } from "react-query";

import type { ReportSummaryApi } from "../../api/Reports";
import { useAppContext } from "../../AppProviders";
import {
  fetchMisconductListReportSummary,
  type MisconductListTabKey,
} from "./misconductListMappers";

export type { MisconductListTabKey } from "./misconductListMappers";
export {
  buildMisconductListsPath,
  fetchMisconductListReportSummary,
  mapReportSummaryToPendingReviewItems,
  reportSummaryApiToPendingReviewResponse,
} from "./misconductListMappers";

export function useMisconductReportSummaryListQuery(args: {
  tab: MisconductListTabKey;
  individual: boolean;
  names: string;
  page: number;
  pageSize: number;
  /** In-process tab only: failed / ERROR rows (``errors_only=1``). */
  errorsOnly?: boolean;
  enabled?: boolean;
}) {
  const { requestApi } = useAppContext();
  const {
    tab,
    individual,
    names,
    page,
    pageSize,
    errorsOnly = false,
    enabled = true,
  } = args;

  return useQuery<ReportSummaryApi>(
    ["misconductListsV2026", tab, individual, names, page, pageSize, errorsOnly],
    () =>
      fetchMisconductListReportSummary(requestApi, {
        tab,
        individual,
        names,
        page,
        pageSize,
        errorsOnly: tab === "in_process" ? errorsOnly : undefined,
      }),
    {
      enabled: enabled && pageSize > 0,
      staleTime: 30000,
      cacheTime: 5 * 60 * 1000,
      retry: 2,
      keepPreviousData: true,
    }
  );
}
